import { ChevronRight, Comment } from "@mui/icons-material";
import { Card, Divider, IconButton, List, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { Link } from "react-router";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDate, formatTimeRange } from "~/modules/app/util/formatters";

export interface FeedbackListItemProps {
    data: {
        area: string;
        endAt: string;
        startAt: string;
        reports: Array<{
            id: string;
            protocol: string;
            numberOfComments: number;
        }>;
    };
}

export function FeedbackListItem({ data }: FeedbackListItemProps) {
    const startAt = parseStringToDate(data.startAt);
    const endAt = parseStringToDate(data.endAt);

    return (
        <Card component="li" variant="outlined">
            <Stack alignItems="center" direction="row" justifyContent="space-between" padding={2}>
                <Typography variant="h6">{data.area}</Typography>
                <Typography>
                    {formatDate(startAt)} | {formatTimeRange(startAt, endAt)}
                </Typography>
            </Stack>

            <Divider />

            <List>
                {data.reports.map(report => {
                    const secondaryAction = (
                        <Stack alignItems="center" direction="row" columnGap={1}>
                            <Typography>{report.numberOfComments}</Typography>
                            <Comment />

                            <IconButton>
                                <ChevronRight />
                            </IconButton>
                        </Stack>
                    );

                    return (
                        <ListItemButton
                            component={Link}
                            key={report.id}
                            to={`/fieldworker/feedback/${report.id}`}
                            sx={{ padding: 0 }}
                        >
                            <ListItem secondaryAction={secondaryAction}>
                                <ListItemText primary={report.protocol} />
                            </ListItem>
                        </ListItemButton>
                    );
                })}
            </List>
        </Card>
    );
}
